import { render, staticRenderFns } from "./CricleSquare.vue?vue&type=template&id=30d6bdbe&"
import script from "./CricleSquare.vue?vue&type=script&lang=js&"
export * from "./CricleSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports